import { Position, useReactFlow, useUpdateNodeInternals } from '@xyflow/react';
import { useState, useEffect } from 'react';
import { useTrashNode } from './commons/trashNode';
import { FlowHandle } from './commons/flowHandle';
import { GlobalNodeIndicator } from './commons/globalNodeBadge';
import NodeHeaderActionsMenu from './commons/nodeHeaderActionsMenu';
import './style.scss';
import SimpleLabelTextBox from 'pub-components/ui-controls/ui-components/SimpleLabelTextbox';
import { useEdges } from '@xyflow/react';

export default function ChatTransferNode({ id, data, editable = true }) {
  const { setNodes, setEdges } = useReactFlow();
  const trashNode = useTrashNode();
  const edges = useEdges();

  const DEFAULT_TRANSITIONS = [
    { id: `transition-${id}-0`, value: 'Success' },
    { id: `transition-${id}-1`, value: 'Failure' }
  ];

  const [items] = useState(
    data?.transitions?.length ? data.transitions : DEFAULT_TRANSITIONS
  );

  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    updateNodeInternals(id);
  }, []);

  useEffect(() => {
    updateNodeInternals(id);
  }, []);
  // 🔹 Sync node data
  const onChange = newData => {
    setNodes(nds =>
      nds.map(node =>
        node.id === id ? { ...node, data: { ...node.data, ...newData } } : node
      )
    );
  };

  const IsValidConnection = connection => {
    // limit 1 connection per source handle
    if (edges.some(edge => edge.sourceHandle === connection.sourceHandle))
      return false;

    return true;
  };

  // 🔹 Persist transitions on first mount
  useEffect(() => {
    if (!data?.transitions || data.transitions.length === 0) {
      onChange({ transitions: items });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <dl className="mt-3" style={{ width: '290px' }}>
      {/* Left (incoming) handle */}
      <FlowHandle
        type="target"
        position={Position.Left}
        id={`${id}-target`}
        editable={editable}
        isConnectable={true}
      />
      <div
        className="card shadow-sm border-gray rounded-10"
        style={{ backgroundColor: '#F9F9F9' }}
      >
        <div
          className="d-flex align-items-center px-4 node-header"
          style={{ backgroundColor: '#E5F6FF' }}
        >
          <div className="d-flex mr-auto ml-2">
            <dt
              className="text-truncate fw-semibold fs-6"
              style={{ color: '#1476A7' }}
            >
              Chat Transfer Node
              <GlobalNodeIndicator isGlobal={data?.isGlobal} />
            </dt>
          </div>
          <div className="ms-auto">
            <NodeHeaderActionsMenu
              nodeId={id}
              editable={editable}
              iconColor="#1476A7"
              title="Chat Transfer actions"
              onDelete={e => trashNode(e, id)}
            />
          </div>
        </div>

        <div className="card-body p-2">
          <div className="mb-3 position-relative">
            {/* Transitions */}
            <div className="px-4 pb-3">
              <dt className="text-truncate small fw-medium mt-3 px-4 label-text">
                Transition
              </dt>

              {items.map(item => (
                <div
                  key={item.id}
                  className="mt-1 d-flex align-items-center gap-4 position-relative fw-semibold mb-2"
                >
                  {/* Source handle */}
                  <FlowHandle
                    type="source"
                    position={Position.Right}
                    id={item.id}
                    style={{
                      right: '-13px',
                      top: '50%'
                    }}
                    editable={false}
                    isConnectable={true}
                    isValidConnection={IsValidConnection}
                  />

                  {/* Read-only label */}
                  <SimpleLabelTextBox
                    dataProperty={item.value}
                    editable={false}
                    inputStyles={{
                      backgroundColor: '#f1f3f5',
                      cursor: 'not-allowed'
                    }}
                    inputPropStyle={{ padding: '10px' }}
                    styles={{ flex: 1 }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <FlowHandle
        type="source"
        position={Position.Right}
        id={`transition-${id}-0-default`}
        style={{
          right: '0px',
          top: '50%'
        }}
        isConnectable={true}
        editable={editable}
        isValidConnection={IsValidConnection}
      /> */}
    </dl>
  );
}
